import type { HTTPError } from 'services/api/entities';
import { Nullable } from 'types';
import type { BaseActionStore } from './types';

export const checkLoadingSelector = (
  state: BaseActionStore,
  actionsToCheck: Array<string>
): boolean => {
  const { actions } = state;
  return actions.some((action) => actionsToCheck.includes(action.type));
};

export const checkErrorSelector = (
  state: BaseActionStore,
  actionsToCheck: Array<string>
): Nullable<HTTPError> => {
  const { errorActions } = state;

  let error: Nullable<HTTPError> = null;
  errorActions.forEach((action) => {
    if (actionsToCheck.includes(action.type)) {
      error = action.payload;
    }
  });
  return error;
};

export const checkSuccessSelector = (
  state: BaseActionStore,
  actionsToCheck: Array<string>
): boolean => {
  const { successActions } = state;

  return successActions.some((action) => actionsToCheck.includes(action.type));
};
